// src/data/pharmacistMockData.js

export const pharmacistNotificationMockData = [
  {
    id: 1,
    content: 'Prescription for John Doe has been filled.',
    sender: 'Dr. Arvind Kumar',
    type: 'Prescription',
    read: false,
  },
  {
    id: 2,
    content: 'Low stock alert: Sertraline.',
    sender: 'Inventory System',
    type: 'Inventory',
    read: false,
  },
  {
    id: 3,
    content: 'Supplier has confirmed delivery of new stock for Fluoxetine.',
    sender: 'Pharma Supplier',
    type: 'Supplier',
    read: true,
  },
  {
    id: 4,
    content: 'Urgent: Expired stock of Lorazepam found.',
    sender: 'Inventory System',
    type: 'Alert',
    read: false,
  },
];
